import React from 'react'
import { EvalComment } from '../SingleEvaluationForm/evaluationForm.api'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'
import withStyles, { Theme, WithStyles } from 'beam/dist/styles'
import { msToHHMMSS } from 'beam/dist/utils/time'
import moment from 'moment/moment'

const styles = () => ({
})

class CommentIcon extends React.Component<{ theme: Theme, comment: EvalComment | undefined, messageTimestamp: number } & WithStyles<typeof styles> & WithTranslation> {
  public render() {
    const { theme, comment, messageTimestamp } = this.props
    const size = theme.spacing(2)
    const { t } = this.props

    if (!comment) {
      return <></>
    }

    const initial = t('comment')?.charAt(0).toUpperCase()
    const createdDate = moment(comment.created).tz(comment.tz).format('L')

    return (
      <Tooltip
        disableFocusListener
        title={
          <div>
            <div><em><b>{`${t('comment')}`}</b></em></div>
            <div>{`${t('text')}: ${comment.text}`}</div>
            <div>{`${t('by')}: ${comment.commentor.displayId}`}</div>
            <div>{`${t('time')}: ${msToHHMMSS(messageTimestamp)}`}</div>
            <div>{`${t('created')}: ${createdDate}`}</div>
          </div>
        }
      >
        <div
          style={{
            width: size,
            height: size,
            backgroundColor: '#FCC5C0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            fontFamily: 'monospace',
            fontSize: size + 'px',
          }}
        >
          {initial ? initial : 'C'}
        </div>
      </Tooltip>
    )
  }
}

export default withStyles({}, { withTheme: true })(withTranslation()(CommentIcon))
